import React, { useEffect, useState } from 'react';
import { Fab, TextField, Typography, Tooltip } from '@material-ui/core';
import { OpenWith, Delete } from '@material-ui/icons';
import { FileObject } from 'material-ui-dropzone';
import { useStyles } from './styles';

interface IProps {
  file: FileObject;
  description: string;
  index: number;
  deleteFile: (file: FileObject, index: number) => void;
  expandImg: (src: string, name: string) => void;
  setOpenImg: (value: boolean) => void;
  setDescription: React.Dispatch<React.SetStateAction<string[]>>;
}

const ImageThumbnail: React.FC<IProps> = ({
  file,
  description,
  setDescription,
  index,
  deleteFile,
  expandImg,
  setOpenImg,
}) => {
  const classes = useStyles();
  const [imgDescription, setImgDescription] = useState<string>(description);

  const handleDescChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setImgDescription(event.target.value);
  };

  const setFileDescription = () => {
    setDescription((prev) => {
      prev[index] = imgDescription
      return [...prev];
    });
  };

  useEffect(() => {
    setImgDescription(description)
  }, [description, index]);

  return (
    <div className={classes.imgContainer}>
      <div className={classes.imgPreviewContainer}>
        <img
          alt={file.file.name}
          src={file.data as string}
          className={classes.imagePreview}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip title="Expadir imagem" arrow placement="bottom">
            <Fab
              size="small"
              style={{ margin: 5, zIndex: 5 }}
              onClick={() => {
                expandImg(file.data as string, file.file.name);
                setOpenImg(true);
              }}
            >
              <OpenWith />
            </Fab>
          </Tooltip>
          <Tooltip title="Remover arquivo" arrow placement="bottom">
            <Fab
              size="small"
              style={{ margin: 5, zIndex: 5 }}
              onClick={() => deleteFile(file, index)}
            >
              <Delete />
            </Fab>
          </Tooltip>
        </div>
      </div>
      <div style={{ width: '100%' }}>
        <Typography variant="subtitle1" style={{ marginBottom: 5 }}>
          {file.file.name}
        </Typography>
        <Typography variant="subtitle2">Descrição do arquivo</Typography>
        <TextField
          size="small"
          className={classes.imgDescription}
          variant="outlined"
          placeholder="Descrição do arquivo"
          value={imgDescription}
          onChange={handleDescChange}
          onBlur={setFileDescription}
          multiline
          rows={3}
          rowsMax={6}
        />
      </div>
    </div>
  );
};

export default ImageThumbnail;
